// pages/NewRegistrationForm.jsx
import { useState, useEffect, useRef } from "react";
import BlockUi from "react-block-ui";
import { Card } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-input-2";
import {
  Avatar, Box, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, Typography,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

import RazorPay from "../../components/RazorPay";
import ProfileService from "../../api/ProfileService";
import { API_URL, BASE_URL, REACT_APP_SITE_KEY } from "../../config/app-config";
import {
  getCategoryListV2,
  getSubscriptionList,          // ← same as YuukkeLandingV2
} from "../../redux/actions/calendarAction";
import { getAllCommonLanguageList } from "../../redux/actions/commonApiActions";

// ─── Static defaults ───────────────────────────────────────────────────────
const DEFAULT_LANGUAGE     = [{ label: "English", value: 3, language: "ENGLISH", id: 3 }];
const DEFAULT_CATEGORY     = [{ label: "General", value: 1, pId: 1 }];
const DEFAULT_ABOUT        = "Service provider on Yuukke";
const DEFAULT_SERVICE_NAME = "My Service";

// ─── Styles (same as YuukkeLandingV2) ─────────────────────────────────────
const styles = `
  .yk2-root *, .yk2-root *::before, .yk2-root *::after { box-sizing: border-box !important; }
  .yk2-root {
    --yk2-red:#a00030;--yk2-red-light:#c0003a;--yk2-red-dark:#7a0024;
    --yk2-bg:#fff9f7;--yk2-surface:#ffffff;--yk2-ink:#1a0a0f;--yk2-muted:#6b4550;
    --yk2-border:#f0dde3;--yk2-radius:16px;
    font-family:'DM Sans',system-ui,-apple-system,sans-serif!important;
    font-size:18px!important;line-height:1.7!important;background:#fff9f7;
    color:#1a0a0f;overflow-x:hidden;-webkit-font-smoothing:antialiased;
  }
  .yk2-root h1,.yk2-root h2,.yk2-root h3,.yk2-root h4,.yk2-root h5,.yk2-root h6{
    margin:0!important;padding:0!important;font-weight:inherit!important;
    font-size:inherit!important;line-height:inherit!important;color:inherit!important;
    border:none!important;background:none!important;
  }
  .yk2-root p,.yk2-root ul,.yk2-root li,.yk2-root a,.yk2-root span{margin:0!important;padding:0!important;}
  .yk2-root ul{list-style:none!important;}
  .yk2-root a{text-decoration:none!important;color:inherit!important;}
  @keyframes yk2-ripple{to{transform:scale(4);opacity:0}}
  @keyframes yk2-spin{to{transform:rotate(360deg)}}
  @keyframes yk2-checkPop{0%{transform:scale(0)}60%{transform:scale(1.2)}100%{transform:scale(1)}}
  @keyframes yk2-fadeUp{from{opacity:0;transform:translateY(36px)}to{opacity:1;transform:translateY(0)}}
  @keyframes yk2-pulse-ring{0%{box-shadow:0 0 0 0 rgba(160,0,48,.4)}70%{box-shadow:0 0 0 16px rgba(160,0,48,0)}100%{box-shadow:0 0 0 0 rgba(160,0,48,0)}}

  .yk2-root .yk2-btn-primary{background:#a00030!important;color:#fff!important;border:none!important;cursor:pointer!important;font-family:'DM Sans',system-ui,sans-serif!important;font-size:1.05rem!important;font-weight:600!important;padding:.9rem 2rem!important;border-radius:10px!important;transition:background .2s,transform .15s,box-shadow .2s;position:relative!important;overflow:hidden!important;line-height:1.4!important;}
  .yk2-root .yk2-btn-primary:hover{background:#c0003a!important;transform:translateY(-2px)!important;box-shadow:0 8px 24px rgba(160,0,48,.3)!important}
  .yk2-root .yk2-rpl{position:relative!important;overflow:hidden!important}
  .yk2-root .yk2-ripple-el{position:absolute!important;border-radius:50%!important;background:rgba(255,255,255,.3)!important;transform:scale(0)!important;animation:yk2-ripple .6s linear!important;pointer-events:none!important}
  .yk2-root .yk2-form-card{background:#fff!important;border-radius:24px!important;padding:3.5rem!important;box-shadow:0 24px 64px rgba(160,0,48,.12)!important;border:1px solid #f0dde3!important}
  .yk2-root .yk2-form-card .blocking-message-overlay{border-radius:24px!important}
  .yk2-root .yk2-form-title{font-family:'Playfair Display',Georgia,serif!important;font-size:2.4rem!important;font-weight:800!important;line-height:1.25!important;margin-bottom:.75rem!important;color:#1a0a0f!important}
  .yk2-root .yk2-form-subtitle{color:#6b4550!important;font-size:1.1rem!important;margin-bottom:2.25rem!important;line-height:1.7!important}
  .yk2-root .yk2-field-group{display:flex!important;flex-direction:column!important;gap:1.65rem!important;margin-bottom:2rem!important}
  .yk2-root .yk2-field{display:flex!important;flex-direction:column!important;gap:.5rem!important}
  .yk2-root .yk2-field label{font-size:1.05rem!important;font-weight:700!important;color:#1a0a0f!important;letter-spacing:.01em!important}
  .yk2-root .yk2-field input,.yk2-root .yk2-field select,.yk2-root .yk2-field textarea{width:100%!important;padding:1.15rem 1.4rem!important;border:1.5px solid #f0dde3!important;border-radius:12px!important;font-family:'DM Sans',system-ui,sans-serif!important;font-size:1.1rem!important;color:#1a0a0f!important;background:#fff!important;outline:none!important;transition:border-color .2s,box-shadow .2s;resize:vertical!important;line-height:1.6!important;}
  .yk2-root .yk2-field input:focus,.yk2-root .yk2-field select:focus,.yk2-root .yk2-field textarea:focus{border-color:#a00030!important;box-shadow:0 0 0 4px rgba(160,0,48,.1)!important}
  .yk2-root .yk2-field input::placeholder,.yk2-root .yk2-field textarea::placeholder{color:#b8929e!important;font-size:1.05rem!important}
  .yk2-root .yk2-field-hint{font-size:.9rem!important;color:#6b4550!important;margin-top:.3rem!important}
  .yk2-root .yk2-form-submit{width:100%!important;background:#a00030!important;color:#fff!important;border:none!important;border-radius:14px!important;padding:1.3rem!important;font-family:'DM Sans',system-ui,sans-serif!important;font-weight:700!important;font-size:1.2rem!important;cursor:pointer!important;transition:background .2s,transform .15s,box-shadow .2s;display:flex!important;align-items:center!important;justify-content:center!important;gap:.5rem!important;letter-spacing:.01em!important;}
  .yk2-root .yk2-form-submit:hover:not(:disabled){background:#c0003a!important;transform:translateY(-2px)!important;box-shadow:0 12px 32px rgba(160,0,48,.35)!important}
  .yk2-root .yk2-form-submit:disabled{opacity:.7!important;cursor:not-allowed!important}
  .yk2-root .yk2-form-privacy{font-size:.9rem!important;color:#6b4550!important;text-align:center!important;margin-top:1.1rem!important}
  .yk2-root .yk2-form-step-bar{display:flex!important;align-items:center!important;gap:0!important;margin-bottom:2rem!important;width:100%!important}
  .yk2-root .yk2-form-step-dot{width:36px!important;height:36px!important;border-radius:50%!important;border:2px solid #f0dde3!important;display:flex!important;align-items:center!important;justify-content:center!important;font-size:.88rem!important;font-weight:700!important;color:#6b4550!important;transition:all .3s;flex-shrink:0!important;z-index:1!important}
  .yk2-root .yk2-form-step-dot.active{background:#a00030!important;border-color:#a00030!important;color:#fff!important}
  .yk2-root .yk2-form-step-dot.done{background:#15803d!important;border-color:#15803d!important;color:#fff!important}
  .yk2-root .yk2-form-step-line{flex:1!important;height:2px!important;background:#f0dde3!important;border-radius:0!important;min-width:0!important}
  .yk2-root .yk2-form-step-line.done{background:#15803d!important}
  .yk2-root .yk2-otp-wrap{display:flex!important;gap:.85rem!important;justify-content:center!important;margin:1.5rem 0!important}
  .yk2-root .yk2-otp-input{width:56px!important;height:66px!important;text-align:center!important;font-size:1.5rem!important;font-weight:700!important;border:2px solid #f0dde3!important;border-radius:12px!important;font-family:'DM Sans',system-ui,sans-serif!important;color:#1a0a0f!important;outline:none!important;transition:border-color .2s,box-shadow .2s;background:#fff!important}
  .yk2-root .yk2-otp-input:focus{border-color:#a00030!important;box-shadow:0 0 0 4px rgba(160,0,48,.1)!important}
  .yk2-root .yk2-sub-cards{display:flex!important;flex-direction:column!important;gap:1.1rem!important;margin-bottom:1.75rem!important}
  .yk2-root .yk2-sub-card{border:2px solid #f0dde3!important;border-radius:16px!important;padding:1.6rem 1.85rem!important;cursor:pointer!important;transition:all .25s cubic-bezier(.22,1,.36,1)}
  .yk2-root .yk2-sub-card:hover{border-color:#a00030!important;transform:translateY(-2px)!important;box-shadow:0 8px 24px rgba(160,0,48,.12)!important}
  .yk2-root .yk2-sub-card.selected{border-color:#a00030!important;background:#fff5f7!important}
  .yk2-root .yk2-sub-card-name{font-weight:700!important;font-size:1.15rem!important;margin-bottom:.3rem!important;color:#1a0a0f!important}
  .yk2-root .yk2-sub-card-price{font-size:1.7rem!important;font-weight:800!important;color:#a00030!important}
  .yk2-root .yk2-sub-card-desc{font-size:.92rem!important;color:#6b4550!important;margin-top:.55rem!important;line-height:1.7!important}
  .yk2-root .yk2-form-success{text-align:center!important;padding:2.75rem 1rem!important}
  .yk2-root .yk2-success-icon{width:84px!important;height:84px!important;border-radius:50%!important;background:#f0fdf4!important;border:2px solid #bbf7d0!important;display:flex!important;align-items:center!important;justify-content:center!important;font-size:2.6rem!important;margin:0 auto 1.4rem!important;animation:yk2-checkPop .5s cubic-bezier(.22,1,.36,1) both}
  .yk2-root .yk2-success-h{font-family:'Playfair Display',Georgia,serif!important;font-size:2rem!important;font-weight:800!important;margin-bottom:.6rem!important;color:#1a0a0f!important}
  .yk2-root .yk2-success-p{color:#6b4550!important;font-size:1.1rem!important;line-height:1.7!important}

  /* REFERRAL BADGE */
  .yk2-referral-badge{display:flex!important;align-items:center!important;gap:.6rem!important;background:linear-gradient(135deg,#fff5f7,#fff9f7)!important;border:1.5px solid #f0dde3!important;border-left:4px solid #a00030!important;border-radius:12px!important;padding:.9rem 1.1rem!important;margin-bottom:1.5rem!important;animation:yk2-fadeUp .5s cubic-bezier(.22,1,.36,1) both}
  .yk2-referral-badge-icon{font-size:1.4rem!important;flex-shrink:0!important}
  .yk2-referral-badge-text{display:flex!important;flex-direction:column!important;gap:.15rem!important}
  .yk2-referral-badge-label{font-size:.75rem!important;font-weight:700!important;letter-spacing:.08em!important;text-transform:uppercase!important;color:#a00030!important}
  .yk2-referral-badge-code{font-size:1rem!important;font-weight:700!important;color:#1a0a0f!important;letter-spacing:.04em!important}
  .yk2-referral-badge-amount{font-size:.85rem!important;color:#6b4550!important}
  .yk2-referral-discount{display:inline-block!important;background:#f0fdf4!important;border:1px solid #bbf7d0!important;border-radius:20px!important;padding:.25rem .75rem!important;font-size:.8rem!important;font-weight:700!important;color:#15803d!important;margin-left:.5rem!important}

  /* PhoneInput */
  .yk2-root .yk2-field .react-tel-input .form-control{font-size:1.1rem!important;padding:1.15rem 1.4rem 1.15rem 58px!important;height:auto!important;border-radius:12px!important;border:1.5px solid #f0dde3!important;width:100%!important;line-height:1.6!important;}
  .yk2-root .yk2-field .react-tel-input .form-control:focus{border-color:#a00030!important;box-shadow:0 0 0 4px rgba(160,0,48,.1)!important;}
  .yk2-root .yk2-field .react-tel-input .flag-dropdown{border-radius:12px 0 0 12px!important;border:1.5px solid #f0dde3!important;border-right:none!important;}

  @media(max-width:768px){
    .yk2-root .yk2-form-card{padding:2.25rem 1.75rem!important;border-radius:16px!important;}
    .yk2-root .yk2-form-title{font-size:1.75rem!important;}
    .yk2-root .yk2-form-subtitle{font-size:1rem!important;margin-bottom:1.75rem!important;}
    .yk2-root .yk2-field input,.yk2-root .yk2-field select,.yk2-root .yk2-field textarea{font-size:1rem!important;padding:1rem 1.1rem!important;}
    .yk2-root .yk2-field label{font-size:.95rem!important;}
    .yk2-root .yk2-otp-wrap{gap:.5rem!important;justify-content:center!important;}
    .yk2-root .yk2-otp-input{width:calc((100% - 2.5rem) / 6)!important;min-width:38px!important;max-width:52px!important;height:52px!important;font-size:1.2rem!important;}
    .yk2-root .yk2-form-step-dot{width:30px!important;height:30px!important;font-size:.8rem!important;}
  }
  @media(max-width:600px){
    .yk2-root .yk2-form-card{padding:1.75rem 1.25rem!important;border-radius:12px!important;}
  }
`;

// ─── Initial State ─────────────────────────────────────────────────────────
const INITIAL_STATE = {
  userName:       "",
  email:          "",
  phoneNumber:    "",
  otp:            "",
  otpId:          null,
  directoryId:    null,
  loader:         false,
  activeMenu:     0,
  subscriptionId: null,
  paymentAmount:  "",
  initId:         null,
  isAnnual:       true,
  userId:         null,
  try:            0,     // ← same field name as old RegistrationForm
};

// ─── OTP Input ─────────────────────────────────────────────────────────────
function OtpInput({ length = 6, onOtpSubmit }) {
  const [otp, setOtp] = useState(Array(length).fill(""));
  const inputs = useRef([]);

  const handleChange = (i, val) => {
    if (!/^\d?$/.test(val)) return;
    const next = [...otp];
    next[i] = val;
    setOtp(next);
    onOtpSubmit(next.join(""));
    if (val && i < length - 1) inputs.current[i + 1]?.focus();
  };

  const handleKeyDown = (i, e) => {
    if (e.key === "Backspace" && !otp[i] && i > 0)
      inputs.current[i - 1]?.focus();
  };

  return (
    <div className="yk2-otp-wrap">
      {otp.map((digit, i) => (
        <input
          key={i}
          ref={(el) => (inputs.current[i] = el)}
          className="yk2-otp-input"
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={digit}
          onChange={(e) => handleChange(i, e.target.value)}
          onKeyDown={(e) => handleKeyDown(i, e)}
        />
      ))}
    </div>
  );
}

// ─── Step Bar ──────────────────────────────────────────────────────────────
function FormStepBar({ active, total }) {
  return (
    <div className="yk2-form-step-bar">
      {Array.from({ length: total }, (_, i) => (
        <>
          <div
            key={`dot-${i}`}
            className={`yk2-form-step-dot ${
              i < active ? "done" : i === active ? "active" : ""
            }`}
          >
            {i < active ? "✓" : i + 1}
          </div>
          {i < total - 1 && (
            <div
              key={`line-${i}`}
              className={`yk2-form-step-line${i < active ? " done" : ""}`}
            />
          )}
        </>
      ))}
    </div>
  );
}

// ─── Referral Badge ────────────────────────────────────────────────────────
function ReferralBadge({ code, amount, campaign }) {
  return (
    <div className="yk2-referral-badge">
      <span className="yk2-referral-badge-icon">🎁</span>
      <div className="yk2-referral-badge-text">
        <span className="yk2-referral-badge-label">
          {campaign === "referral" ? "Referral Applied" : "Promo Applied"}
        </span>
        <span className="yk2-referral-badge-code">
          {code}
          <span className="yk2-referral-discount">Special Offer</span>
        </span>
        {amount && (
          <span className="yk2-referral-badge-amount">
            Offer amount: <strong>₹{Number(amount).toLocaleString("en-IN")}</strong>
          </span>
        )}
      </div>
    </div>
  );
}

// ─── Ripple ────────────────────────────────────────────────────────────────
function ripple(e) {
  const btn = e.currentTarget;
  const rect = btn.getBoundingClientRect();
  const size = Math.max(rect.width, rect.height);
  const el = document.createElement("span");
  el.className = "yk2-ripple-el";
  el.style.cssText = `width:${size}px;height:${size}px;top:${
    e.clientY - rect.top - size / 2
  }px;left:${e.clientX - rect.left - size / 2}px`;
  btn.appendChild(el);
  el.addEventListener("animationend", () => el.remove());
}

// ─── Main Component ────────────────────────────────────────────────────────
const NewRegistrationForm = ({ location }) => {
  const dispatch     = useDispatch();
  const recaptchaRef = useRef();

  // ── Parse referral query params ───────────────────────────────────────
  const queryParams    = new URLSearchParams(location?.search);
  const referralCode   = queryParams.get("code")     || "";
  const referralAmount = queryParams.get("amount")   || "";
  const campaign       = queryParams.get("campaign") || "";
  const isReferral     = campaign === "referral" && !!referralCode;

  // ── Redux — exactly same pattern as YuukkeLandingV2 ──────────────────
  const { categoryList, subscriptionList } = useSelector((state) => state.event);
  const { languagelist }                   = useSelector((state) => state.commonApi);

  useEffect(() => {
    dispatch(getSubscriptionList("service"));
    dispatch(getAllCommonLanguageList());
    dispatch(getCategoryListV2());
  }, []);

  // ── Referral toast on mount ───────────────────────────────────────────
  useEffect(() => {
    if (isReferral) {
      toast.success(`Referral code "${referralCode}" applied! 🎁`);
    }
  }, [isReferral]);

  // ── Form state ────────────────────────────────────────────────────────
  const [state, setState]                               = useState(INITIAL_STATE);
  const [extUsr, setExtUsr]                             = useState({});
  const [showExtUsr, setShowExtUsr]                     = useState(false);

  const updateState = (name, value) =>
    setState((prev) => ({ ...prev, [name]: value }));

  // ── Resolve helpers — same as old RegistrationForm ───────────────────
  const resolveLanguage = () =>
    languagelist?.length > 0
      ? [{ label: languagelist[0].label, value: languagelist[0].value }]
      : DEFAULT_LANGUAGE;

  const resolveCategory = () =>
    categoryList?.length > 0
      ? [{ label: categoryList[0].label, value: categoryList[0].value, pId: categoryList[0].pId || 1 }]
      : DEFAULT_CATEGORY;

  // ── Effective price with referral override ────────────────────────────
  const effectivePrice = (planPrize) =>
    isReferral && referralAmount ? Number(referralAmount) : planPrize;

  // ── Append referral fields to FormData ────────────────────────────────
const appendReferral = (fd) => {
    // Remove isReferral gate — just check if referralCode has a value
    if (referralCode && referralCode.trim() !== "") {
        fd.append("referralCode", referralCode.trim());
        fd.append("campaign",     campaign || "referral");
        if (referralAmount) fd.append("referralAmount", String(referralAmount));
        
        console.log("Referral appended:", { referralCode, campaign, referralAmount });
    } else {
        console.log("No referralCode found, skipping referral append");
    }
};

  // ── API: openPaymentPage (same as old) ────────────────────────────────
  const openPaymentPage = (prize, id) => {
    setState((prev) => ({
      ...prev,
      paymentAmount:  effectivePrice(prize),
      subscriptionId: id,
    }));
  };

  // ── API: sendOtp (same logic as old RegistrationForm) ─────────────────
  const sendOtp = (e, menu) => {
    if (state.try === 4) {
      toast.warning("You tried maximum times, please try later!");
      return;
    }
    if (state.phoneNumber.length < 6) {
      toast.warning("Enter valid phone number");
      return;
    }
    updateState("loader", true);

    ProfileService.sendOtp({
      type:         "phone",
      phoneNumber:  state.phoneNumber,
      optModelName: "Service",
    })
      .then((response) => {
        if (response.data.data?.id) {
          setState((prev) => ({
            ...prev,
            otpId:      response.data.data.id,
            loader:     false,
            activeMenu: menu + 1,
            try:        prev.try + 1,
          }));
        }
      })
      .catch(() => {
        toast.error("Something went wrong");
        updateState("loader", false);
      });
  };

  // ── API: saveInitDetails (same logic as old RegistrationForm) ─────────
  const saveInitDetails = (e, menu) => {
    const langs = resolveLanguage();
    const cats  = resolveCategory();

    const formData = new FormData();
    formData.append("userName",     state.userName.trim());
    formData.append("email",        state.email?.trim());
    formData.append("phoneNumber",  state.phoneNumber?.trim());
    formData.append("serviceName",  DEFAULT_SERVICE_NAME);
    formData.append("description",  DEFAULT_ABOUT);
    formData.append("businessName", state.userName.trim());
    formData.append("language",     JSON.stringify({ data: langs.map((l) => ({ language: l.label, id: l.value })) }));
    formData.append("categoryV2",   JSON.stringify({ data: cats.map((c) => ({ primaryId: c.pId, categoryId: c.value })) }));
    if (state.directoryId) formData.append("directoryId", state.directoryId);
    appendReferral(formData);

    const config = { headers: { "content-type": "multipart/form-data" } };

    ProfileService.directoryAndServiceRegisterInit(formData, config)
      .then((response) => {
        if (response.data.status === 2 || response.data.status === 3) {
          const usrFromDb = response.data.data;
          setExtUsr(usrFromDb);
          setState((prev) => ({
            ...prev,
            email:       usrFromDb.email,
            userName:    usrFromDb.displayName,
            userId:      usrFromDb.userId,
            phoneNumber: usrFromDb.mobileNumber,
          }));
          setShowExtUsr(true);
          return;
        }
        if (response.data?.data?.id) {
          sendOtp(e, menu);
          updateState("initId", response.data.data.id);
        }
      })
      .catch(() => {
        toast.error("Something went wrong");
        updateState("loader", false);
      });
  };

  // ── API: verifyOtp (same as old) ──────────────────────────────────────
  const verifyOtp = () => {
    if (state.otp.length !== 6) {
      toast.warning("Enter valid OTP");
      return;
    }
    updateState("loader", true);

    ProfileService.validateUserOtp({ otp: state.otp, id: state.otpId })
      .then((response) => {
        if (response.data.data === "VALID_OTP") {
          setState((prev) => ({
            ...prev,
            activeMenu: prev.activeMenu + 1,
            loader:     false,
          }));
        } else {
          toast.error("Wrong OTP");
          updateState("loader", false);
        }
      })
      .catch(() => {
        toast.error("Something went wrong");
        updateState("loader", false);
      });
  };

  // ── API: updateDetails (same as old) ──────────────────────────────────
  const updateDetails = (paymentId) => {
    const langs = resolveLanguage();
    const cats  = resolveCategory();

    const formData = new FormData();
    formData.append("firstName",      state.userName.trim());
    formData.append("lastName",       state.userName.trim().substring(0, 1));
    formData.append("email",          state.email);
    formData.append("phoneNumber",    state.phoneNumber);
    formData.append("serviceName",    DEFAULT_SERVICE_NAME);
    formData.append("description",    DEFAULT_ABOUT);
    formData.append("businessName",   state.userName.trim());
    formData.append("language",       JSON.stringify({ data: langs.map((l) => ({ language: l.label, id: l.value })) }));
    formData.append("categoryV2",     JSON.stringify({ data: cats.map((c) => ({ primaryId: c.pId, categoryId: c.value })) }));
    formData.append("categoryId",     cats[0]?.value);
    formData.append("categoryName",   cats[0]?.label);
    formData.append("subscriptionId", state.subscriptionId);
    formData.append("paymentId",      paymentId);
    if (state.directoryId) formData.append("directoryId", state.directoryId);
    if (state.initId)      formData.append("initId",      state.initId);
    appendReferral(formData);

    const config = { headers: { "content-type": "multipart/form-data" } };

    ProfileService.directoryAndServiceRegister(formData, config)
      .then((response) => {
        if (response.data.status !== 1) {
          toast.error("Something went wrong, please try again later");
          setState((prev) => ({
            ...prev,
            otpId:          null,
            loader:         false,
            otp:            "",
            subscriptionId: null,
          }));
        } else {
          setState((prev) => ({
            ...prev,
            otpId:          null,
            loader:         false,
            otp:            "",
            activeMenu:     prev.activeMenu + 1,
            subscriptionId: null,
          }));
        }
      })
      .catch(() => {
        toast.error("Something went wrong, please try again later");
        setState((prev) => ({
          ...prev,
          otpId:  null,
          loader: false,
          otp:    "",
        }));
      });
  };

  // ── updatePaymentStatus (same as old) ────────────────────────────────
  const updatePaymentStatus = (status, id) => {
    if (status === "dismiss") {
      Swal.fire({
        icon:              "error",
        title:             "Payment updating failed!",
        text:              "If your money was debited, please contact our team at +91 04446314646",
        showConfirmButton: true,
      }).then(() => {
        setState((prev) => ({
          ...prev,
          paymentAmount:  null,
          subscriptionId: null,
          loader:         false,
        }));
      });
    } else {
      updateState("loader", true);
      updateDetails(id);
    }
  };

  // ── changeScreen (same as old) ────────────────────────────────────────
  const changeScreen = (e, menu) => {
    e.preventDefault();
    e.stopPropagation();
    const captchaValue = recaptchaRef?.current?.getValue();
    if (!captchaValue) {
      toast.warning("Please verify the reCAPTCHA!");
      return;
    }
    if (menu === 0) {
      saveInitDetails(e, menu);
    } else {
      updateState("activeMenu", menu + 1);
    }
  };

  const onContinueWithExtUsr = () => {
    setShowExtUsr(false);
    setState((prev) => ({ ...prev, activeMenu: 2 }));
  };

  const loginYuukke = () => window.open(BASE_URL, "_blank");

  // ── Render ────────────────────────────────────────────────────────────
  return (
    <div className="yk2-root">
      <style>{styles}</style>

      <div
        style={{
          minHeight:      "100vh",
          background:     "#fff9f7",
          display:        "flex",
          alignItems:     "center",
          justifyContent: "center",
          padding:        "2rem 1rem",
        }}
      >
        <div style={{ width: "100%", maxWidth: "520px" }}>
          <div className="yk2-form-card">
            <BlockUi
              tag="div"
              message="Loading, please wait"
              style={{ minHeight: "100%" }}
              className="wallLoadingPage pb-3"
              blocking={state.loader}
            >

              {/* ── Step 0: Details ── */}
              {state.activeMenu === 0 && (
                <>
                  <h2 className="yk2-form-title">Let's get started 🚀</h2>
                  <p className="yk2-form-subtitle">
                    Join 500+ women entrepreneurs. Set up your profile in minutes.
                  </p>
                  <FormStepBar active={0} total={4} />

                  {isReferral && (
                    <ReferralBadge
                      code={referralCode}
                      amount={referralAmount}
                      campaign={campaign}
                    />
                  )}

                  <form onSubmit={(e) => changeScreen(e, 0)}>
                    <div className="yk2-field-group">

                      <div className="yk2-field">
                        <label>What's Your Name? *</label>
                        <input
                          type="text"
                          placeholder="Kavitha Menon"
                          value={state.userName}
                          onChange={(e) => updateState("userName", e.target.value)}
                          required
                        />
                      </div>

                      <div className="yk2-field">
                        <label>Where Can We Reach You By Email? *</label>
                        <input
                          type="email"
                          placeholder="kavitha@example.com"
                          value={state.email}
                          onChange={(e) => updateState("email", e.target.value)}
                          required
                        />
                      </div>

                      <div className="yk2-field">
                        <label>And Your Phone Number? *</label>
                        <div style={{ marginTop: "4px" }}>
                          <PhoneInput
                            country="in"
                            containerClass="input-dark"
                            value={state.phoneNumber}
                            placeholder=""
                            countryCodeEditable={false}
                            onChange={(phone) => updateState("phoneNumber", phone)}
                          />
                        </div>
                        <span className="yk2-field-hint">
                          We'll send your OTP to this number
                        </span>
                      </div>

                    </div>

                    <div
                      style={{
                        background:   "#fff9f7",
                        border:       "1px solid #f0dde3",
                        borderRadius: 10,
                        padding:      "0.85rem 1rem",
                        fontSize:     "0.85rem",
                        color:        "#6b4550",
                        marginBottom: "1.25rem",
                        lineHeight:   1.65,
                      }}
                    >
                      ✏️ You can update your <strong>business name, category, language, and service details</strong> anytime from your profile after signing up.
                    </div>

                    <div
                      style={{
                        marginTop:    "1rem",
                        marginBottom: "1rem",
                        minHeight:    "78px",
                        display:      "flex",
                        justifyContent: "center",
                      }}
                    >
                      <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey={REACT_APP_SITE_KEY}
                        theme="light"
                        size="normal"
                      />
                    </div>

                    <button
                      type="submit"
                      className="yk2-form-submit yk2-rpl"
                      onClick={ripple}
                    >
                      Get OTP →
                    </button>
                    <p className="yk2-form-privacy">
                      🔒 Your data is encrypted and never shared.
                    </p>
                  </form>
                </>
              )}

              {/* ── Step 1: OTP ── */}
              {state.activeMenu === 1 && (
                <div
                  className="card p-3 m-auto"
                  style={{ maxWidth: "30rem", textAlign: "start", boxShadow: "none" }}
                >
                  <h2 className="yk2-form-title">Verify Your Number</h2>
                  <p className="yk2-form-subtitle">
                    OTP sent to <strong>+{state.phoneNumber?.slice(2)}</strong>. Enter the 6-digit code below.
                  </p>
                  <FormStepBar active={1} total={4} />

                  <Card className="profileCard align-items-center" style={{ border: "none" }}>
                    <p style={{ fontSize: "12px" }} className="text-secondary mt-3 text-center">
                      Please enter your OTP!
                    </p>
                    <div className="p-3 d-flex g-1 align-items-center justify-content-center service-otp">
                      <OtpInput
                        length={6}
                        onOtpSubmit={(otp) => updateState("otp", otp)}
                      />
                    </div>
                    <button
                      className="yk2-form-submit yk2-rpl mt-3 mb-3"
                      style={{ width: "fit-content", padding: ".75rem 2rem" }}
                      onClick={(e) => { ripple(e); verifyOtp(); }}
                    >
                      Verify OTP →
                    </button>
                  </Card>

                  <p className="yk2-form-privacy" style={{ marginTop: ".75rem" }}>
                    Didn't receive it?{" "}
                    <span
                      style={{ color: "#a00030", cursor: "pointer", fontWeight: 600 }}
                      onClick={() => sendOtp(null, 0)}
                    >
                      Resend OTP
                    </span>
                  </p>
                </div>
              )}

              {/* ── Step 2: Payment ── */}
              {state.activeMenu === 2 && (
                <div>
                  <h2 className="yk2-form-title">Choose Your Plan</h2>
                  <p className="yk2-form-subtitle">Lifetime access — pay once, use forever.</p>
                  <FormStepBar active={2} total={4} />

                  {isReferral && (
                    <ReferralBadge
                      code={referralCode}
                      amount={referralAmount}
                      campaign={campaign}
                    />
                  )}

                  {state.subscriptionId && (
                    <RazorPay
                      email={state.email}
                      name={state.userName}
                      userId={null}
                      contactNumber={state.phoneNumber}
                      subscriptionId={state.subscriptionId}
                      amount={state.paymentAmount}
                      type="Service-Register"
                      updatePaymentStatus={updatePaymentStatus}
                      initId={state.initId}
                      uId={state.userId}
                    />
                  )}

                  <div className="yk2-sub-cards">
                    {/* Same render as old RegistrationForm */}
                    {subscriptionList && subscriptionList.length > 0 ? (
                      subscriptionList.map((data) => {
                        const isDisabled = data.prize === 0;
                        return (
                          <div
                            key={data.id}
                            className={`yk2-sub-card${
                              state.subscriptionId === data.id ? " selected" : ""
                            }${isDisabled ? " disabled-card" : ""}`}
                            style={{
                              cursor:  isDisabled ? "not-allowed" : "pointer",
                              opacity: isDisabled ? 0.6 : 1,
                            }}
                            onClick={() => {
                              if (!isDisabled) openPaymentPage(data.prize, data.id);
                            }}
                          >
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                              <div>
                                {state.isAnnual && (
                                  <div className="yk2-sub-card-name" style={{ textDecorationLine: "line-through", opacity: 0.5 }}>
                                    Annual Subscription
                                  </div>
                                )}
                                <div className="yk2-sub-card-name">{data.subscriptionName}</div>
                                <div
                                  className="yk2-sub-card-desc"
                                  dangerouslySetInnerHTML={{
                                    __html: data.subscribeDescription.replace(/<p><\/p>/g, "<br/>"),
                                  }}
                                />
                              </div>
                              {data.prize !== 0 && (
                                <div style={{ textAlign: "right", flexShrink: 0, marginLeft: "1rem" }}>
                                  {/* Strike original if referral discount */}
                                  {isReferral && referralAmount && Number(referralAmount) !== data.prize && (
                                    <div style={{ fontSize: ".8rem", color: "#6b4550", textDecoration: "line-through", marginBottom: ".2rem" }}>
                                      ₹{data.prize.toLocaleString("en-IN")}
                                    </div>
                                  )}
                                  <div className="yk2-sub-card-price">
                                    ₹{effectivePrice(data.prize).toLocaleString("en-IN")}
                                  </div>
                                  <div style={{ fontSize: ".8rem", color: "#6b4550" }}>one-time</div>
                                </div>
                              )}
                            </div>
                            {state.subscriptionId === data.id && (
                              <div style={{ marginTop: ".75rem", color: "#a00030", fontSize: ".82rem", fontWeight: 700 }}>
                                ✓ Selected — click to pay
                              </div>
                            )}
                          </div>
                        );
                      })
                    ) : (
                      // Loading spinner while Redux fetches
                      <div style={{ textAlign: "center", padding: "2rem", color: "#6b4550" }}>
                        <div style={{
                          width: 32, height: 32,
                          border: "3px solid #f0dde3",
                          borderTopColor: "#a00030",
                          borderRadius: "50%",
                          animation: "yk2-spin .7s linear infinite",
                          margin: "0 auto 1rem",
                        }} />
                        Loading plans...
                      </div>
                    )}
                  </div>

                  <p className="yk2-form-privacy">
                    🔒 Secured via Razorpay · UPI · Cards · Net Banking
                  </p>
                </div>
              )}

              {/* ── Step 3: Success ── */}
              {state.activeMenu === 3 && (
                <div className="yk2-form-success">
                  <FormStepBar active={4} total={4} />
                  <div className="yk2-success-icon">🎉</div>
                  <h3 className="yk2-success-h">Welcome to Yuukke!</h3>
                  <p className="yk2-success-p">
                    Your profile is being set up. We'll WhatsApp you at{" "}
                    <strong>+{state.phoneNumber}</strong> with your login details.
                  </p>
                  {isReferral && (
                    <p style={{ marginTop: ".75rem", fontSize: ".9rem", color: "#15803d", fontWeight: 600 }}>
                      🎁 Referral bonus from <strong>{referralCode}</strong> has been recorded!
                    </p>
                  )}
                  <button
                    className="yk2-btn-primary yk2-rpl"
                    style={{ marginTop: "1.5rem", padding: ".75rem 2rem" }}
                    onClick={(e) => { ripple(e); loginYuukke(); }}
                  >
                    Go to Dashboard →
                  </button>
                  <div style={{ marginTop: "1.5rem" }}>
                    <img
                      onClick={loginYuukke}
                      src="https://corporate.yuukke.com/bcav2/auth/image/7cdb6739-68d5-407b-ac71-4eccc422685c"
                      alt="Welcome"
                      style={{ width: "100%", borderRadius: "12px", cursor: "pointer", objectFit: "cover" }}
                    />
                  </div>
                </div>
              )}

            </BlockUi>
          </div>
        </div>
      </div>

      {/* ── Existing user dialog — same as old RegistrationForm ── */}
      <Dialog
        open={showExtUsr}
        onClose={() => setShowExtUsr(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>User Already Exists</DialogTitle>
        <DialogContent>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            p={2}
            style={{ border: "1px solid hsl(220 13% 91%)", borderRadius: "8px" }}
          >
            <Avatar
              src={`${API_URL}auth/image/${extUsr.profilePhoto}`}
              style={{ width: 80, height: 80, marginRight: 16 }}
            />
            <Box display="flex" flexDirection="column">
              <Typography variant="subtitle1">{extUsr.displayName || ""}</Typography>
              <Typography variant="body1">{extUsr.email || ""}</Typography>
              <Typography variant="body2" color="textSecondary">
                {extUsr.mobileNumber || ""}
              </Typography>
            </Box>
          </Box>
          <Typography variant="subtitle1" color="textSecondary" align="center" style={{ marginTop: 12 }}>
            You already have an account. Shall we continue with this account?
          </Typography>
          <Box display="flex" justifyContent="center" mt={1}>
            <Typography variant="caption" color="textSecondary" align="center">
              Note: Please use this existing account credentials for all future services.
              If you don't remember your credentials, use "Forgot Password" with this email:{" "}
              <strong>{extUsr.email}</strong>
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setShowExtUsr(false)}
            color="secondary"
            variant="outlined"
            style={{ color: "brown", background: "transparent" }}
          >
            Cancel
          </Button>
          <Button onClick={onContinueWithExtUsr} color="primary" variant="contained">
            Continue
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
};

export default withTranslation()(withRouter(NewRegistrationForm));